export default __webpack_public_path__ + "static/media/Background 5_00010.5ec53355.png";